export default function toHashStringUtil (str) {
  return `#${str}`
}
